// DocContext.js
import { createContext, useContext, useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { auth, db } from "../Admin/Config/Config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [docData, setDocData] = useState(null);

  useEffect(() => {
    let unsubscribeUser = null; // to store Firestore unsubscribe
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userRef = doc(db, "users", user.uid);
        // attach Firestore listener
        unsubscribeUser = onSnapshot(userRef, (snapshot) => {
          if (snapshot.exists()) {
            setDocData(snapshot.data());
          } else {
            setDocData(null);
          }
        });
      } else {
        setDocData(null);
        if (unsubscribeUser) unsubscribeUser();
      }
    });

    // cleanup on unmount
    return () => {
      unsubscribeAuth();
      if (unsubscribeUser) unsubscribeUser();
    };
  }, []);

  return (
    <UserContext.Provider value={docData}>{children}</UserContext.Provider>
  );
};

export const useDocData = () => useContext(UserContext);
